import {
  blue100,
  blue150,
  grey200,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  height: ${spacing(13)};
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  cursor: pointer;
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};

  &.small {
    padding: ${spacing(2)};
  }

  &.medium {
    padding: ${spacing(2)} ${spacing(5)};
  }

  .secondary {
    color: ${text_colorTextSecondary};
  }

  .selected-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${spacing(6)};
    height: ${spacing(6)};
    min-width: ${spacing(6)};
    min-height: ${spacing(6)};
  }
  .option-label-wrapper {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    overflow: hidden;
  }

  .option-sublabel {
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  .ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &:hover,
  &:focus,
  &[aria-selected='true'] {
    background-color: ${grey200};
    outline: none;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover,
    &:focus,
    &[aria-selected='true'] {
      background-color: transparent;
    }
  }

  &.selected {
    background-color: ${blue100};
    &:hover,
    &:focus,
    &[aria-selected='true'] {
      background-color: ${blue150};
    }
  }
`
